export default __webpack_public_path__ + "static/media/Nomark.31d73247.otf";